<!-- 618活动  TopicPage -->
<template>
     <div class="topicPage" >
        <!-- 618专题页活动
        {{TopicId}}
        {{access_token}} -->
        <div v-if="datasList.length>0">
            <div  v-for="(item, index) of datasList" :key="index">
                  <ActivityPage :ItemDate="item" :access_token="access_token"></ActivityPage>
            </div>
         
        </div>
        
    </div>
</template>
<script>
import ActivityPage from "./ActivityTheme/ActivityPage.vue";
  import {
    getTopicList
  } from '../api/topicPage.js'
  export default {
    name: "topicPage",
    components: {
       ActivityPage
    },
    data() {
      return {
          access_token: '', //token
          TopicId:'',
          datasList:[],//专题页数据
      };
    },

    created() {
    

     // // 模拟数据  start
      // let access_token='bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRfaWQiOiIxMDQ3MDQiLCJjb21wYW55X3R5cGUiOiIwMyIsInRoaXNfcm9sZV9pZCI6bnVsbCwidXNlcl9uYW1lIjoiMTMyMDE3MzY0NDQiLCJtZW1iZXJfbGV2ZWxfaWQiOi0xLCJmZF9mbGFnIjpmYWxzZSwiZW1wb3dlcl9zdGF0dXMiOjEsInJlYWxfbmFtZSI6IueOi-eCs-S5viIsImF1ZGl0X3N0YXR1cyI6NCwiY2xpZW50X2lkIjoiM2FrLXBjIiwiZGlzYWJsZV9zdGF0dXMiOjAsInVzZXJfdHlwZSI6InBjIiwicm9sZV9pZCI6IjExMjM1OTg4MTY3Mzg2NzUyMDIiLCJzY29wZSI6WyJhbGwiXSwib2F1dGhfaWQiOiIiLCJpZF90eXBlIjoyLCJtZW1iZXJfc3RvcmVfaWQiOjMzNTQ5LCJleHAiOjE4MzQ5MDg0MzcsImp0aSI6IjZkMmIxNDdjLTQ5OTEtNGIzZi1hMjQyLWYwYTA4NDAxMWMyZCIsIm1lbWJlcl9pZCI6MTM1OTAwODI0NDA3NjQwMDY0MSwic3RvcmVfaWQiOi0xLCJhdmF0YXIiOiIiLCJhdXRob3JpdGllcyI6WyJ1c2VyIl0sInJvbGVfbmFtZSI6InVzZXIiLCJsaWNlbnNlIjoicG93ZXJlZCBieSBibGFkZXgiLCJwb3N0X2lkIjoiIiwidXNlcl9pZCI6IjMzNTQ5Iiwibmlja19uYW1lIjoi546L54Kz5Lm-IiwiZGVwb3NpdF9zdGF0dXMiOjIsImRlcHRfaWQiOiIiLCJhY2NvdW50IjoiMTMyMDE3MzY0NDQiLCJzdGF0dXMiOjF9.IbNaEvyi2D4VSs1snCkoumsfO68Qy6mEj6Aej9byBls'
      // this.access_token=access_token
      // this.TopicId='1838875989873602562'
      // getTopicList(access_token, this.TopicId ).then(res=>{
      //   //   console.log('woow',res.data)
      //     this.datasList=res.data

      //   //   alert(this.datasList.length>0)
      // })
      // // 模拟数据  end

    },
    methods: {
        // http://172.16.0.239:8081/#/topicPage?Id=666555
        //跳转路径后，获取topicId

        // 安卓app调js  跳转路径后，获取topicId
        getAPPDate() {
            let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {

            } else {
                this.$bridge.registerHandler("getTopicId", (data, responseCallback) => {
                    // alert("2222安卓app主动调用js getTopicId:" + data)
                    this.TopicId=data

                    // let access_token = "bearer " + data
                    // activityPics(access_token).then(res => {
                    // this.picsArr = res.data.data.activityDetail
                    // })
                    //  alert(333)
                    if(this.access_token!=''){
                            getTopicList(this.access_token, this.TopicId).then(res => {
                                    // alert(4444)
                                  this.datasList=res.data
                                  //  传递name   transmitName

                            })
                        }
                    responseCallback(data);
                });
                
                this.$bridge.registerHandler("getToken", (data, responseCallback) => {
                    console.log("安卓app主动调用js getToken:" + data);
                    this.access_token = "bearer " + data
                        // 安卓获取页面数据接口
                        // alert(111111)

                    responseCallback(data);
                });
                 
            }
        },
        getTopicId(TopicId) {
            let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
            //苹果app调取js方法
            //    console.log(TopicId)
            // alert(222)
               this.TopicId=TopicId
                //   alert(this.access_token!='')
               if(this.access_token!=''){
                        // 苹果获取页面数据接口
                        getTopicList(this.access_token, this.TopicId).then(res => {
                             this.datasList=res.data


                            //  传递name   transmitName
                        })
                    //  alert("获取app响应数据:" + access_token);
                }
               
            }
        },
         getToken(token) {
            let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isiOS) {
                // 苹果app调取js方法
                // alert("苹果app调取js方法"+token);
                console.log(token)
                //  alert(111)
                this.access_token = "bearer " + token
                
                
            }
        },

    },
     //   注册方法
    mounted() {
      // 注册安卓方法 ,获取专题页面Id
      window.getTopicId = this.getTopicId  //ios使用
       window.getToken = this.getToken //ios使用
      this.getAPPDate();

    }
  }
</script>
<style>
.topicPage{
    width: 100% ;
    display: block;
    height: auto;
    /* width: calc(100% - 0.24rem);
    padding: 0.12rem; */
    /* border-radius: 0.1rem; */
    color: #333;
    font-size: 0.12rem;
    line-height: 0.21rem;
    text-align: center;
    /* white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; */
  }
</style>


// WEBPACK FOOTER //
// src/components/TopicPage.vue